
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../base/Button';

export default function Header() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const handleBookClass = () => {
    // Trigger Readdy Agent widget for booking
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    } else {
      // Fallback to contact page
      navigate('/contact');
    }
  };

  const navigation = [
    { name: t('nav.home'), href: '/' },
    { name: t('nav.about'), href: '/about' },
    { name: t('nav.courses'), href: '/courses' },
    { name: t('nav.wallOfFame'), href: '/wall-of-fame' },
    { name: t('nav.workWithUs'), href: '/work-with-us' },
    { name: t('nav.contact'), href: '/contact' }
  ];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
              <i className="ri-book-open-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold text-emerald-600" style={{ fontFamily: '"Pacifico", serif' }}>
              MathLish
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-gray-700 hover:text-emerald-600 font-medium transition-colors ${
                  location.pathname === item.href ? 'text-emerald-600 border-b-2 border-emerald-600' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Language Switcher & CTA */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <button
                onClick={() => changeLanguage('uk')}
                className={`px-3 py-1 rounded-md text-sm font-medium transition-all duration-300 ease-in-out language-button hover-effect ${
                  i18n.language === 'uk' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:text-emerald-600'
                }`}
              >
                УК
              </button>
              <button
                onClick={() => changeLanguage('en')}
                className={`px-3 py-1 rounded-md text-sm font-medium transition-all duration-300 ease-in-out language-button hover-effect ${
                  i18n.language === 'en' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:text-emerald-600'
                }`}
              >
                EN
              </button>
            </div>
            
            <Button 
              size="sm" 
              className="hidden md:block cta-button"
              onClick={handleBookClass}
            >
              {t('cta.bookClass')}
            </Button>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-600 hover:text-emerald-600 transition-all duration-300 ease-in-out menu-button hover-effect"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-gray-700 hover:text-emerald-600 font-medium transition-colors ${
                    location.pathname === item.href ? 'text-emerald-600' : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Button 
                size="sm" 
                className="w-full mt-4 cta-button"
                onClick={handleBookClass}
              >
                {t('cta.bookClass')}
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
